export default {
  All: 'All',
  Rented: 'Rented',
  Idle: 'Idle',
  meau: {
    back: '공식 웹사이트로 돌아가기',
    nav1: '오리온 대회',
    nav2: '장기 대여 모드',
    nav3: '단기 대여 모드',
    nav4: '장치 목록',
  },
  footer: {
    link: '자세히 알아보기',
    community: '커뮤니티 팔로우',
    tip: '설명: 커뮤니티에는 Twitter, Telegram, Reddit, Medium, Discord, TikTok, YouTube가 포함됩니다',
  },

  home: {
    title1: 'Orion',
    title2: 'GPU 연산 성능 대회',
    text: 'DeepLink 프로토콜의 Orion GPU 연산력 대회는 채굴자들이 DeepLink 네트워크 테스트에 적극 참여하도록 독려하는 중요한 인센티브 대회입니다. 이 대회는 세계 최대의 클라우드 게임 프로토콜 플랫폼인 DeepLink의 공식 출시 전 중요한 준비 단계로, 향후 글로벌 사용자들에게 견고한 기술 기반과 효율적인 연산 지원을 제공합니다',
    text1: '현재 DeepLink 네트워크의 GPU 총 수는 {gpu_num}입니다',
    text2: '대회가 시작되었습니다. GPU 수가 기준에 도달하면 보상이 시작됩니다!',
    btn_text1: '장기 렌탈 모드 대회 - 종료됨',
    btn_title1: '현재 {long_term} GPUs',

    btn_text2: '단기 임대 모드 대회 - 4단계',

    btn_title2: '현재 {short_term} GPUs',
    cont2_text1:
      'Orion 연산 성능 대회의 총 토큰 보상은 30억 개이며, 장기 대여 모드에는 20억 DLC, 단기 대여 모드에는 10억 DLC가 제공되며, 총 180일 동안 지속됩니다. 대회는 60일씩 3회에 걸쳐 진행되며, 각 회차 간에는 5~10일 간의 간격이 있습니다.',
    cont2_btn1: '장기 대여 모드',
    cont2_btn2: '단기 대여 모드',
    text5: '총 DLC 보상',
    cont3: {
      text1: '총 연산 능력 값',
      text2: 'GPU 총 수',
      text3: '연산 풀 총 수',
      text4: 'GPU 대여율',
      text5: 'DLC 대여 수',
      text6: 'DLC 소각 수',
      text7: '채굴기용 DLC 담보 수',
      text8: '온라인 GPU 수',
      text9: '온라인 GPU 임대율',
    },
    cont4: {
      li1: '경쟁 순위',
      li2: '채굴자 이름',
      li3: '연산 능력',
      li4: 'GPU 수',
      li5: '대여율',
      li6: '대여 수',
      li7: '잠금 해제된 보상',
      li8: '총 보상',
      li9: '온라인 GPU 수',
      li10: '온라인 GPU 임대율',
    },
  },
  long_rule: {
    title: '장기 대여 모드 경쟁 규칙',
    text1: '현재 DeepLink 네트워크의 장기 대여 모드에서 GPU 총 수는 {long_num}입니다',
    text2:
      '경쟁 기간 동안 채굴자는 총 20억 DLC의 보상을 받을 수 있으며, 사용자가 지불한 DLC 임대 요금의 100%는 소각됩니다',
    competition_phase_two_in_progress: '대회 2단계가 진행 중입니다',
    cont2: {
      title: '1. 참가 규칙',
      text1_1: '오리온 연산 능력 대회에 참가하는 채굴자는 노드 NFT를 소유해야 합니다 ( 노드에 대해 자세히 알아보기: ',
      text1_2:
        '). 대회 기간 동안 하나의 GPU 기계는 여러 노드를 보유할 수 있으며, 보상 토큰의 수는 노드의 수에 비례합니다. 기계당 노드 NFT의 최대 수는 20개입니다.',
      text2_1:
        'GPU 서버의 최소 요구 사항: \n 연산 능력 서버는 최소 요구 사항을 충족해야 하며, \n 검증자의 심사를 통과하여 온라인 상태가 되어야 하며, 그렇지 않으면 수익을 얻을 수 없습니다.',
      text3_1: 'GPU',
      text3_2: 'Nvidia 시리즈 그래픽 카드여야 하며, 모델은 20, 30, 40, 50 시리즈',
      text4_1: '메모리',
      text4_2: '카드당 최소 요구 사항은 16G이며, 32G 권장',
      text5_1: 'CPU',
      text5_2:
        '클라우드 게임의 요구 사항을 충족해야 합니다: Intel/AMD, 기본 주파수 3.0GHz 또는 터보 주파수 3.5GHz 이상; 각 GPU에는 별도의 CPU가 필요하며 Black Myth: Wukong을 원활하게 실행할 수 있어야 합니다. 예: Intel 10세대 이상, AMD 5600 이상',
      text6_1: '하드 디스크',
      text6_2:
        '시스템 디스크는 100G SSD 이상이어야 하며, 데이터 디스크는 3T SSD 이상이거나 디스크 없는 시스템을 사용할 수 있습니다',
      text7_1: '위치',
      text7_2: '불안정한 네트워크와 전력으로 인한 처벌을 피하기 위해 IDC 데이터 센터에 기계를 배치하는 것이 좋습니다',
      text8_1: '네트워크 대역폭',
      text8_2: '각 GPU 기계에는 최소 10M 업스트림 대역폭을 갖추는 것이 좋습니다',
    },
    cont3: {
      title: '2. 연산 성능 계산 규칙',
      text: '전체 생태계에서 사용자 단말기의 임대 요금은 연산 성능 값 시스템 가격에 따라 통일됩니다. DLC 임대 수익은 0.6 USD/C/월입니다. 계산 모델은 다음과 같습니다: 전체 기계 연산 성능 = (25 * 카드 수 + 메모리/3.5 + (√(CUDA 코어 수) * √(메모리/10)) * GPU 수), 로컬 지역 계수가 1일 때 연산 성능 값은 다음과 같습니다:',
      li1: 'GPU 유형',
      li2: 'CUDA 코어',
      li3: '메모리',
      li4: 'GPU 수',
      li5: '메모리 (G)',
      li6: '전체 기계 연산 성능 (C)',
      li7: '전체 기계 임대료 (USD)',
      li8: '카드당 월 임대 요금 (USD)',
    },
    cont4: {
      title: '3. 지역 계수',
      li1: '지역',
      li2: '계수',
      li_text1: '중국 본토',
      li_text2: '북아메리카',
      li_text3: '남아메리카',
      li_text4: '유럽',
      li_text5: '중동',
      li_text6: '한국',
      li_text7: '일본',
      li_text8: '대만, 중국',
      li_text9: '홍콩 및 마카오, 중국',
      li_text10: '말레이시아',
      li_text11: '인도네시아',
      li_text12: '싱가포르',
      li_text13: '베트남',
      text1:
        '기계 연산 성능 계산 공식: (25 * 카드 수 + 메모리/3.5 + (√(CUDA 코어 수) * √(메모리/10)) * GPU 수) * 지역 계수 * 대형 모델 계수',
      text2: '기계 모델:',
      text3: 'GPU 수:',
      text4: '메모리 크기:',
      text5: '지역:',
      text6: '선택하세요',
      text7: '현재 기계의 연산 성능 값은: {total}',
    },
    cont5: {
      title: '4. 보상 메커니즘 (DBC AI 퍼블릭 체인의 EVM 호환 DLC 기반, 브라우저 주소: https://test.dbcscan.io/)',
      text1:
        '오리온 연산 성능 대회의 IDC 장기 임대 모드 GPU 머신에 대한 총 토큰 보상은 20억 개이며, 180일 동안 지속됩니다. 대회는 3회로 나누어지며, 각 라운드 사이의 간격은 5-10일입니다.',
      text2: '경기 1: 각 유형의 GPU 수가 {n_gpu1}개에 도달했을 때 공식적으로 대회가 시작됩니다.',
      text3:
        '60일 동안 하루에 600만 개의 토큰, 10%는 즉시 지급되며, 90%는 180일 동안 잠금 해제되며, 매일 0.5%씩 잠금 해제됩니다.',
      text4: '경기 2: 각 유형의 GPU 수가 {n_gpu2}개에 도달했을 때 공식적으로 대회가 시작됩니다.',
      text5:
        '60일 동안 하루에 800만 개의 토큰, 10%는 즉시 지급되며, 90%는 180일 동안 잠금 해제되며, 매일 0.5%씩 잠금 해제됩니다.',
      text6: '경기 3: 각 유형의 GPU 수가 {n_gpu3}개에 도달했을 때 공식적으로 대회가 시작됩니다.',
      text7:
        '60일 동안 하루에 1933만 개의 토큰, 10%는 즉시 지급되며, 90%는 180일 동안 잠금 해제되며, 매일 0.5%씩 잠금 해제됩니다.',
      text8: '거래소에 상장된 후 테스트 토큰은 1:1 비율로 메인넷 토큰으로 교환할 수 있습니다.',
      text9: 'DeepLink는 비선형 보상 알고리즘을 사용합니다.',
      text10:
        '이 시스템의 일일 보상 토큰 수는 고정되어 있습니다. 머신이 받는 보상은 머신의 계산 능력 X, 유효 채굴 시간 Y 및 스테이킹된 토큰 수와 관련이 있습니다. 스테이킹된 토큰이 많을수록 보상이 증가하지만, 이는 선형 성장 관계를 따르지 않습니다. 0~10,000 토큰의 보상 기준은 동일하지만, 10,000 토큰을 초과하면 함수에 따라 보상이 계산됩니다. 머신이 임대 상태에 있는 경우 계산 능력이 30% 증가합니다.',
      text11: '보상 계산 공식:',
      text12: 'R: 일일 보상 토큰의 총량 (고정 값)',
      text13: '머신 i의 스테이킹된 토큰 수',
      text14: '머신 i의 계산 능력',
      text15: '머신 i의 유효 채굴 시간',
      text16: '',
      title1: '스테이킹 수량:',
      text1_1: '1) 스테이킹할 토큰 수를 자유롭게 선택하거나 스테이킹하지 않을 수 있습니다.',
      text1_2:
        '2) 스테이킹 수량이 0~10,000 범위일 경우 보상 수량은 동일합니다. 10,000을 초과하면 보상이 비선형적으로 증가합니다.',
      text1_3:
        '3) 스테이킹 수량이 10,000 미만일 때 각 보상 추출은 스테이킹에 우선적으로 기여되며, 10,000이 충족될 때까지 지속됩니다.',
      text1_4:
        '4) 100,000 토큰의 보상은 10,000 토큰을 스테이킹할 때의 1.23026배로, 약 23.03% 증가입니다. 1,000,000 토큰의 경우 보상은 1.46052배로 약 46.05% 증가하며, 10,000,000 토큰의 경우 1.69078배로 약 69.08% 증가하고, 100,000,000 토큰의 경우 1.92103배로 약 92.10% 증가합니다.',
      title2: '보상 추출:',
      text2_1:
        '24시간마다 보상을 추출할 수 있습니다. 각 추출 시 새로 생성된 보상의 10%는 즉시 추출 가능하며, 90%는 180일 동안 잠금됩니다. 잠금된 부분은 각 추출 시 0.5%씩 해제되며, 180일 후에 완전히 해제됩니다.',
      block_title1: '특별 주의:',
      block_text1_1: '장기 렌탈 모드는 먼저 GPU 머신을 DBC 네트워크에 추가해야 합니다. 참고 문서:',
      block_text1_2:
        '이후, 채굴자는 직접 머신을 렌탈한 후에야 DLC 네트워크에 가입할 수 있으며, 이를 통해 DBC와 DLC 수익을 모두 얻을 수 있습니다. DBC 네트워크에 가입한 후의 DBC 수익 = DBC 보상 - 30% 렌탈 요금.',
      block_title2: '머신의 하루 DBC 수익 계산 공식:',
      block_text2:
        '전체 머신 계산 능력 / 네트워크 전체 계산 능력 * 547,945 * DBC 가격 * 지역 계수 * 1.3 (렌탈된 경우 계산 능력 30% 증가) - 전체 머신 계산 능력 * 지역 계수 * 0.01693 * 30% (단위 계산 능력 당 하루 수익은 0.01693 USD).',
      text3_13:
        '현재 하루 수익은: {usdt1} USD 상당의 DBC = 온체인 보상: {dbc} DBC (현재 DBC 가격 {dbc_price} USD에 해당하는 {usdt2} USD) - 30% 렌탈 요금: {usdt3} USD 상당의 DBC.',
      title4: '머신의 하루 DLC 수익 계산 공식: DLC는 {price} USD로 계산.',
      text4_1: 'GPU 모델:',
      text4_2: '메모리 크기:',
      text4_3: '노드 NFT 수량:',
      text4_4: '지역:',
      text4_5: '스테이킹된 DLC 수량:',
      text4_6: '경쟁 단계:',
      text4_6_1: '1단계: 하루 600만 DLC.',
      text4_6_2: '2단계: 하루 800만 DLC.',
      text4_6_3: '3단계: 하루 1933만 DLC.',
      text4_7: '참여 GPU 총 수:',
      text4_8: '(총 GPU는 4060 모델, 32GB, 평균 10개의 NFT, 평균 10만 개의 스테이킹 토큰을 기준으로 계산됩니다)',
      title5: '온체인 보상: {dlc_num} DLC (현재 DLC 가격 {price} USD일 때 {usdt_num} USD에 해당).',
      req_title1: '5. 신고 및 검증 메커니즘 (DBC AI 퍼블릭 체인의 EVM 호환 DLC 기반)',
      req_text1:
        'DLC 머신을 렌탈한 사용자는 언제든지 신고할 수 있습니다. 신고를 시작하려면 10,000 DLC의 보증금이 필요합니다. 신고 시 신고 정보는 DBC 검증자 검증 프로세스에 들어갑니다.',
      req_title2: '6. 벌칙 메커니즘 (DBC AI 퍼블릭 체인의 EVM 호환 DLC 기반)',
      req_text2:
        'DLC 신고가 검증된 후 문제가 있을 경우, 규칙에 따라 DBC 스테이킹 토큰이 차감됩니다. 최대 10,000 DLC 토큰이 차감되며, 이러한 스테이킹 토큰은 신고자에게 보상으로 지급됩니다.',
      req_title3: '7. 지불 및 소각 메커니즘 (DBC AI 퍼블릭 체인의 EVM 호환 DLC 기반)',
      req_text3:
        '사용자는 DLC를 지불하고 (DLC 네트워크의 GPU 가격은 DBC 네트워크보다 20% 높습니다) 머신의 렌탈 권한을 얻습니다. 사용자가 지불한 DLC는 100% 스마트 계약에서 소각되며, 각 지불 및 소각 기록을 조회할 수 있습니다.',
    },
  },
  short_rule: {
    title: '단기 임대 모드 대회 규칙',
    text1: 'DeepLink 네트워크의 단기 임대 모드에 있는 GPU 총 수는 현재 {short_num}입니다.',
    text2: '대회 기간 동안 채굴자는 총 10억 DLC의 보상을 받을 수 있으며, 사용자가 지불한 DLC 임대료는 100% 소각됩니다.',
    competition_phase_two_in_progress: '대회 4단계가 진행 중입니다',
    cont2: {
      title: '1. 참여 규칙',
      text1_1:
        '오리온 계산 능력 대회에 참가하려면, 채굴자는 노드 NFT를 보유해야 합니다(달러의 가치가 있습니다. 노드에 대한 자세한 정보:',
      text1_2:
        '). 대회 기간 동안 하나의 GPU 기기는 여러 개의 노드를 보유할 수 있으며, 보상 토큰의 수는 노드 수에 비례합니다. 한 기기가 보유할 수 있는 노드 NFT의 최대 수는 20개입니다.',
      text2_1: 'GPU 서버의 최소 요구 사항: \n 계산 서버의 매개 변수는 최소 요구 사항을 충족해야 합니다.',
      text3_1: 'GPU',
      text3_2: 'Nvidia 시리즈 그래픽 카드여야 하며, 모델은 20, 30, 40, 50 시리즈입니다.',
      text4_1: '메모리',
      text4_2: '각 카드당 최소 메모리 요구 사항은 16G이며, 32G를 권장합니다.',
      text5_1: 'CPU',
      text5_2:
        "클라우드 게임 요구 사항을 충족해야 합니다: Intel/AMD, 기본 주파수 3.0GHz 이상 또는 부스트 주파수 3.5GHz 이상; 각 GPU에는 개별 CPU가 필요하며, 'Black Myth: Wukong'을 원활하게 실행할 수 있어야 합니다. 예: Intel 10세대 이상, AMD 5600 이상.",
      text6_1: '하드 드라이브',
      text6_2: '시스템 디스크 2T SSD 이상, 데이터 디스크 1T 이상',
      text7_1: '위치',
      text7_2: '기기를 가정에 설치할 수 있습니다.',
      text8_1: '네트워크 대역폭:',
      text8_2: '각 GPU 기기는 최소 10M 업로드 대역폭을 갖추어야 합니다.',
    },
    cont3: {
      title: '2. 계산 능력 계산 규칙',
      text: '전체 생태계에서 사용자의 임대 요금은 계산 능력 값 가격 책정 시스템에 따라 일관되게 설정됩니다. DLC 임대 수익은 0.508 USD/C/월입니다. 계산 모델은 다음과 같습니다: 전체 기계의 계산 능력 값 = (25 * 카드 수 + 메모리/3.5 + (√(CUDA 코어 수) * √(비디오 메모리/10)) * 그래픽 카드 수). ',
    },
    cont4: {
      title: '3. 지역 계수',
      li1: '지역',
      li2: '계수',
      li_text1: '중국 본토',
      li_text2: '북아메리카',
      li_text3: '남아메리카',
      li_text4: '유럽',
      li_text5: '중동',
      li_text6: '한국',
      li_text7: '일본',
      li_text8: '대만, 중국',
      li_text9: '홍콩 및 마카오, 중국',
      li_text10: '말레이시아',
      li_text11: '인도네시아',
      li_text12: '싱가포르',
      li_text13: '베트남',
      text1:
        '기계 연산 성능 계산 공식: (25 * 카드 수 + 메모리/3.5 + (√(CUDA 코어 수) * √(메모리/10)) * GPU 수) * 대형 모델 계수',
      text2: '기계 모델:',
      text3: 'GPU 수:',
      text4: '메모리 크기:',
      text5: '지역:',
      text6: '선택하세요',
      text7: '현재 기계의 연산 성능 값은: {total}',
    },
    cont5: {
      title: '4. 보상 메커니즘 (DBC AI 퍼블릭 체인의 EVM 호환 DLC 기반, 브라우저 주소: https://test.dbcscan.io/)',
      text1:
        '오리온 계산 능력 대회의 개별 단기 임대 GPU 머신의 총 토큰 보상은 10억 개이며, 180일 동안 지속됩니다. 대회는 총 3회에 걸쳐 진행되며, 각 대회 간격은 5~10일입니다.',
      text2: '대회 1단계: 각 유형의 GPU 수가 {n_gpu1}대에 도달해야 대회가 공식적으로 시작됩니다.',
      text3: '60일 동안, 매일 300만 개의 토큰, 10% 즉시 해제, 90%는 180일 동안 해제되며, 매일 0.5%씩 해제됩니다.',
      text4: '대회 2단계: 각 유형의 GPU 수가 {n_gpu2}대에 도달해야 대회가 공식적으로 시작됩니다.',
      text5: '60일 동안, 매일 400만 개의 토큰, 10% 즉시 해제, 90%는 180일 동안 해제되며, 매일 0.5%씩 해제됩니다.',
      text6: '대회 3단계: 각 유형의 GPU 수가 {n_gpu3}대에 도달해야 대회가 공식적으로 시작됩니다.',
      text7: '60일 동안, 매일 966.5만 개의 토큰, 10% 즉시 해제, 90%는 180일 동안 해제되며, 매일 0.5%씩 해제됩니다.',
      text8: '거래소에 상장된 후 테스트 토큰은 1:1 비율로 메인넷 토큰으로 교환할 수 있습니다.',
      text9: 'DeepLink는 비선형 보상 알고리즘을 사용합니다.',
      text10:
        '이 시스템의 일일 보상 토큰 수는 고정되어 있습니다. 머신이 받는 보상은 머신의 계산 능력 X, 유효 채굴 시간 Y 및 스테이킹된 토큰 수와 관련이 있습니다. 스테이킹된 토큰이 많을수록 보상이 증가하지만, 이는 선형 성장 관계를 따르지 않습니다. 0~10,000 토큰의 보상 기준은 동일하지만, 10,000 토큰을 초과하면 함수에 따라 보상이 계산됩니다. 머신이 임대 상태에 있는 경우 계산 능력이 30% 증가합니다.',
      text11: '보상 계산 공식:',
      text12: 'R: 일일 보상 토큰 총량 (고정값)',
      text13: '기계 i의 스테이킹된 토큰 수',
      text14: '기계 i의 계산 능력',
      text15: '기계 i의 유효 채굴 시간',
      text16: '',
      title1: '스테이킹 수량:',
      text1_1: '1) 스테이킹할 토큰 수를 자유롭게 선택하거나 스테이킹하지 않을 수 있습니다.',
      text1_2:
        '2) 스테이킹 수량이 0~10,000 범위일 경우 보상 수량은 동일합니다. 10,000을 초과하면 보상이 비선형적으로 증가합니다.',
      text1_3:
        '3) 스테이킹 수량이 10,000 미만일 때 각 보상 추출은 스테이킹에 우선적으로 기여되며, 10,000이 충족될 때까지 지속됩니다.',
      text1_4:
        '4) 100,000 토큰의 보상은 10,000 토큰을 스테이킹할 때의 1.23026배로, 약 23.03% 증가입니다. 1,000,000 토큰의 경우 보상은 1.46052배로 약 46.05% 증가하며, 10,000,000 토큰의 경우 1.69078배로 약 69.08% 증가하고, 100,000,000 토큰의 경우 1.92103배로 약 92.10% 증가합니다.',
      title2: '보상 추출:',
      text2_1_line1:
        '보상은 언제든지 인출할 수 있습니다. 초기 DLC 스테이킹이 없거나 10,000개 미만이면 보상 수익은 10,000개까지 스테이킹된 DLC로 누적됩니다.',
      text2_1_line2: '1) 임대 수익은 10,000 DLC에 도달할 때까지 보증금으로 누적됩니다.',
      text2_1_line3:
        '2) 최소 임대 시간은 2시간이며 최대 제한은 없습니다. 남은 이용 시간이 1시간 미만이면 임대할 수 없고 온라인 보상에도 포함되지 않습니다. 채굴자는 언제든지 시간을 연장할 수 있으며, 연장 시 최소 2시간 이상이어야 합니다.',

      title4: '일일 DLC 수익 계산 공식: DLC는 {price} USD로 계산됩니다.',
      text4_8:
        '(총 GPU는 4060 32G를 기준으로 일관되게 계산되며, 평균 10개의 NFT와 평균 1만 개의 스테이킹 토큰으로 계산됩니다)',
      title5: '온체인 보상 수익: {dlc_num} DLC (현재 DLC 가격 {price} USD일 때 {usdt_num} USD에 해당).',

      req_title1: '5. 온라인 감지 메커니즘',
      req_text1_1:
        '기계는 DBC AI 퍼블릭 체인의 감지 메커니즘에 따라 분산된 DBC 감지 클러스터에 정보를 보고하여 기계가 온라인 상태인지 판단합니다. 온라인 상태가 아닌 경우 온라인 보상이 차감됩니다. 사용자가 사용하는 동안 중단이 발생하면 DLC가 사용자로부터 차감됩니다. 벌칙 한도:',
      req_text1_2:
        '1) 코인이 스테이킹되지 않은 경우 현재 임대 DLC 수익만 벌칙이 부과되며, 최대 2시간의 임대료가 차감됩니다.',
      req_text1_3: '2) DLC가 스테이킹된 경우 1,000 DLC의 벌칙이 부과됩니다.',
      req_text1_4:
        '머신에는 DBC AI 블록체인의 상주 감지 메커니즘이 있으며, 머신의 온라인 상태를 판단하기 위해 정보를 DBC 분산 감지 클러스터에 보고합니다. 온라인 상태가 아닐 경우 온라인 보상이 차감됩니다. 사용 중 중단이 발생하면 사용자에게서 DLC가 차감됩니다. 현재 각 중단 시 1000 DLC의 페널티가 부과되며, 이후 DLC 가격에 따라 동적으로 조정됩니다',
      req_title2: '6. 기계 신고 규칙',
      req_text2:
        '사용자가 기계의 구성이 허위일 수 있다고 판단한 경우 신고를 시작할 수 있습니다. 성공하면 모든 스테이킹된 코인이 기계에서 차감되고 보상이 중단됩니다.',
      req_title3: '10,000 DLC를 스테이킹하고 신고 정보를 체인에 전송',
      req_text3:
        'DeepLink에서 승인된 검증자가 검증에 참여할 수 있습니다. 각 검증에는 5명의 검증자가 참여하며, 과반수 원칙을 따릅니다.',

      text4_6_1: '1단계: 하루 300만 DLC.',
      text4_6_2: '2단계: 하루 400만 DLC.',
      text4_6_3: '3단계: 하루 966.5만 DLC.',
      text4_6_4: '4단계: 하루 966.5만 DLC.',
      text4_6_5: '5단계: 하루 966.5만 DLC.',
    },
  },
  country: {
    country1: '중국',
    country2: '북아메리카',
    country3: '남아메리카',
    country4: '유럽',
    country5: '중동',
    country6: '대한민국',
    country7: '일본',
    country8: '대만, 중국',
    country9: '홍콩 및 마카오, 중국',
    country10: '말레이시아',
    country11: '인도네시아',
    country12: '싱가포르',
    country13: '베트남',
  },
  device: {
    title: '전체 네트워크 장치 목록',
    title1: '다양한 GPU 모델의 기기 수, 기기 상태 및 세부 정보를 확인하십시오.',
    table: {
      text1: '기기 사용 상태:',
      text2: 'GPU 수:',
      text3: '총 기기 수:',
      text4: '유휴 기기 수:',
    },
  },
  machine_id: '기계 ID',
  machine_is_rented: '임대 여부',
  machine_rented: '임대됨',
  machine_idle: '유휴',
  machine_is_online: '온라인 여부',
  machine_yes: '예',
  machine_no: '아니요',
  machine_no_data: '데이터 없음',

  deviceUniqueId: '기계 ID',
  minerLocation: '광부 주소',
  gpuCount: 'GPU 수량',
  computeCapacity: '총 계산 능력',
  isActive: '온라인 상태',
  isPledged: '스테이킹 상태',
  pledgeTotal: '총 스테이킹 금액',
  pledgeExpiration: '스테이킹 종료 시간',

  yesOption: '예',
  noOption: '아니요',
};
